import Tooltip from "./Tooltip";
import './Tooltip.scss';

export default Tooltip